module.exports = __webpack_public_path__ + "static/media/LY.5dbd1648.svg";